module.exports = __webpack_public_path__ + "static/img/logo.372067d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 648
// module chunks = 17